// extracted by mini-css-extract-plugin
module.exports = {"greyLight9":"#d7d7d7","dropbox":"ImageUploader__dropbox","link":"ImageUploader__link","previewImg":"ImageUploader__previewImg"};